import {Category} from "@app/core/category/domain/category";

export class CategoryMapper {
    static deserialize(param: any): Category {
        return {
            code: param.code,
            name: param.name,
            parentCode: param.parentCode,
            topParentCode: param.topParentCode,
            order: parseInt(param.order),
            imageBig: param.imageBigUrl,
            imageSmall: param.imageSmallUrl,
            productsQuantity: param.product_quantity
        }
    }
}
